import Module, { ViewLayer, moduleInit } from "../../../../framework/core/mvvm/module_base";
import TaskView from "./task_view";
import { NotifyData } from "../../../public/notify_data";

const {ccclass, property} = cc._decorator;

@ccclass
@moduleInit('TaskModule')
export class TaskModule extends Module<TaskView,null> {
    constructor(){
        super();
        this.layer = ViewLayer.Mid
        this.windowPrefabResPath = "package/hall/module/gametask/gametask";
        this.viewType = TaskView
        this.modelType = null
        this.autoShowAnim = true
        this.needAnim = true
        this.needViewMask = true
        this.needViewBaseCloseBtn = true;
        this.needViewBaseTitleBg = true
        this.needViewBaseBg = true
        this.needDeferShow = false
        this.clickAnywhereClose = true;
    }

    onInit(){
        this.bindEvent();
        this.initView()
        let self = this
        this.eventBind("hall_show_type", (data) => {  //这种方式有点不优雅
            if (!self.isHide) {
                if (data == "HideHall") {
                    self.node.active = false
                } else if (data == "LoginToHall") {
                    self.scheduleOnce(() => {
                        self.node.active = true
                        self.showAnim(true)
                    }, 0.35)
                }
            }
        })
    }

    onShow(){
        this.view.clickToggle(0);
        this.eventDispatch('Event_Notify_RedPoint')
    }

    bindEvent(){
        let self = this;
        for (let idx = 0; idx < this.view.toggles.length; idx++) {
            let toggle = this.view.toggles[idx];
            toggle.node.on('toggle', function (event: cc.Toggle) {
                if (toggle.isChecked) {
                    self.showNetPrompt(true)
                    self.view.changeTaskPanel(toggle,()=>{
                        self.showNetPrompt(false)
                    })
                }          
            })
        }
     
        this.eventBind('_task_state_',this.setModuleState);
    }

    setModuleState(isShow:boolean){
        if (!isShow) {
            this.hide();
        }
    }

    initView(){
        this.view.initView(this);
    }

    
    onHide(){
        this.view.hide()
    }
}
